import { render } from "./AddDummyDialog.vue?vue&type=template&id=28ff0de2&scoped=true"
import script from "./AddDummyDialog.vue?vue&type=script&lang=js"
export * from "./AddDummyDialog.vue?vue&type=script&lang=js"

import "./AddDummyDialog.vue?vue&type=style&index=0&id=28ff0de2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-28ff0de2"

export default script